export default {
  //new
  "plans": {
    "chooseYourPlan": "Choose your plan",
    "selectPerfectPlan": "Select the perfect plan for your organization",

    "monthly": "Monthly",
    "annual": "Annual",
    "save10": "Save 10%",

    "title": "CoNurse Plan",
    "description": "Access all currently available features on CoNurse.",

    "numberOfUsers": "Number of users",

    "selectPlan": "Select plan",
    "continueToBilling": "Continue to billing details",

    "featureHospital": "Hospital & home nursing functionalities",
    "featureProcedures": "Institution-specific procedures",
    "featurePatientManagement": "Patient management",
    "featureHomeCare": "Home care functionalities",
    "featureMaps": "Google Maps integration for home nursing",
    "featureWellbeing": "Nurse wellbeing monitoring"
  },
  "errors": {
    //new
    "email_duplicate": "Dublicate emails.",
    "oneEmail": "At least one email is required.",
    //end new
    "required": "This field is required",
    "password_invalid": "Password must be at least 8 characters long, contain upper and lowercase letters, a number, and a special character (!#$%^&*)",
    "password_mismatch": "Passwords do not match",
    "minLength": "Password must be at least {minLength} characters long",
    "maxLength": "Password must not exceed {maxLength} characters",
    "capital": "Include at least one uppercase letter",
    "lower": "Include at least one lowercase letter",
    "hasNumber": "Include at least one number",
    "specialChars": "Include at least one special character (!#$%^&*)",
    "passMust": "Password must meet the following requirements:",
    "passwordNotSame": "Passwords do not match",
    "email_invalid": "Please enter a valid email address",
    "INSTITUTION_ALREADY_EXISTS": "Institution name already exists",
    "TRIAL_ALREADY_USED": "Trial already used",
    "ACCESS_DENIED": "Access denied",
    "UNKNOWN_ERROR": "Unknown error"
  },
  "signup": {
    "alreadyhas": "Already have an account?",
    "login": "Log in",
    "title": "Create Account",
    "not_found": "Invitation not found or expired. If you already have an account, try to Log in instead.",
    "intro": "Hi {email}! You have been invited to create a {role} role account at Institution {institution} under Department {department}. Please fill out the following details to complete sign up.",
    "introTrial": "Hi {email}! You have been created an {role} role account at Institution {institution} under Department {department}. Please fill out the following details to complete sign up.",
    "fields": {
      "first_name": "First Name",
      "last_name": "Last Name",
      "date_of_birth": "Date of Birth",
      "started_practising": "When did you start your nursing career?",
      "gender": "Gender",
      "email": "E-mail",
      "password": "Password",
      "password_confirm": "Confirm Password"
    },
    "actions": {
      "signup": "Sign Up",
      "login": "Log In"
    },
    "success": {
      "user_created": "User {name} created successfully"
    }
  },
  "institutionCreation": {
    "institution": {
      "title": "Start free trial",
      "discription": "Welcome! You’re creating a new institution on CoNurse to start a free 30-day trial. Please enter your institution, department, and email details. You will receive an invitation link on that email address to complete your sign-up.",
      "name": "Institution Name",
      "street": "Street",
      "house": "House",
      "city": "City",
      "country": "Country",
      "county": "County / Region",
      "timezone": "Timezone"
    },
    "department": {
      "title": "Department",
      "name": "Department Name"
    },
    "admin": {
      "title": "Institutional Admin User",
      "email": "Admin Email (person setting up the account)"
    },
    "form": {
      "accept_tos": "I agree to the Terms of Service",
      "accept_privacy": "I agree to the Privacy Policy and Data Processing Agreement (DPA)"
    },
    "actions": {
      "start_free_trial": "Start free trial"
    },
    "messages": {
      "created": "Institution successfully created",
      "wesend": "We’ve sent a link to complete your registration to the email address",
      "no_results": "No results"
    }
  },
  "success": {
    "CREATED": "Institution and department created successfully"
  },
  "trialPage": {
    "title": "Trial expired.",
    "message": "Trial ended on {date}. Your data will be deleted on {date2} unless a subscription is activated. Select a plan to continue using CoNurse.",
    "cta": "Select plan",
    "support": "Support"
  },
  "gracePage": {
    "disabled": "Your account disabled!",
    "title": "Your subscription has ended",
    "message": "Your subscription ended on {date}. Your data will be deleted on {date2} unless the subscription is renewed. Select a plan to continue using CoNurse."
  },
  // end-new
  "general": {
    "ok": "Ok",
    "yes": "Yes",
    "no": "No",
    "cancel": "CANCEL",
    //new
    "confirm": "CONFIRM",
    //end new
    "close": "Close",
    "delete": "Delete",
    "remove": "Remove",
    "save": "SAVE",
    "edit": "EDIT",
    "view": "View",
    "add": "Add",
    "selectAll": "Select all",
    "dateAdded": "Date added",
    "dateUpdated": "Date updated",
    "loading": "Loading ...",
    "noData": "No data",
    "back": "Back",
    "accessDenied": "Access Denied",
    "name": "Name",
    "startDate": "Start date",
    "endDate": "End date",
    "open": "Open",
    "action": "Action",
    "categories": "Categories",
    "manage": "MANAGE",
    "saved": "Saved",
    "updated": "Updated",
    "deleted": "Deleted",
    "dragNDropFile": "Drag and drop a file here, or:",
    "browse": "Browse",
    "every": "Every",
    "onceEvery": "Once every",
    "created": "Created",
    "search": "Search",
    "chooseADate": "Choose a date",
    "average": "Average",
    "selectQuestion": "Select question",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "rows": "rows",
    "export": "Export",
    "startTime": "Start time",
    "endTime": "End time",
    "exportLocationHistory": "Export location history",
    "exportArrivalLocationHistory": "Export arrival location history",
    "settings": "Settings",
    "signOut": "Sign Out",
    "clickToSort": "Click to sort",
    "duration": "Duration",
    "visitStart": "Visit start",
    "visitEnd": "Visit end",
    //new
    "subscriptionEnd": "Trial active. Trial ends on {date}. Please choose a plan to continue.",
    "graceActive": "Grace period active. Your access ends on {date}. Please choose a plan to continue.",
    "chooseplan": "Choose plan"
    //end new
  },
  "time": {
    "timePresets": "Time Presets",
    "today": "Today",
    "yesterday": "Yesterday",
    "pastNDays": "Past {n} days",
    "pastYear": "Past year",
    "allTime": "All time",
    "clearSelection": "Clear Selection",
    "jumpToToday": "Jump to Today",
    "previousWeek": "previous week",
    "previousMonth": "previous month"
  },
  "charts": {
    "nMostFrequentlyProcedures": "{n} most frequently started procedures",
    "nLeastFrequentlyProcedures": "{n} least frequently started procedures",
    "oftenAssistedProcedures": "Often assisted procedures",
    "nursesExperience": "Nurses' experience",
    "nursesGender": "Nurses' gender",
    "nursesAge": "Nurses' Age",
    "workIntensityChart": "Work intensity chart",
    "surveyChart": "Survey Chart",
    "nurses": "Nurses",
    "Averageshiftduration": "Average shift duration",
    "Averageshiftintensity": "Average shift intensity",
    "Averagenrofpatients": "Average nr of patients",
    "Averageacuitypershift": "Average acuity per shift",
    "lessThenYear": "Less than 1 year",
    "yearToFiveYears": "1-5 years",
    "fiveToTenYears": "5-10 years",
    "moreThanTenYears": "More than 10 years",
    "maleNurses": "Male nurses",
    "femaleNurses": "Female nurses",
    "tiredness chart": "Tiredness chart",
    "tiredness score": "Tiredness score",
    "intensity score": "Intensity score",
    "work intensity chart": "Work intensity chart",
    "selectStudy": "Select study",
    "count": "Count",
    "tiredness": "Tiredness",
    "intensity": "Intensity"
  },
  "form": {
    "thisFieldIsRequired": "This field is required",
    "canNotStartBeforeParentStarts": "Can not start before parent starts",
    "canNotStartWhenParentEnded": "Can not start when parent ended",
    "canNotEndBeforeParentStarts": "Can not end when parent not started",
    "canNotEndWhenParentEnded": "Can not end when parent ended",
    "canNotEndBeforeStart": "Can not end before start",
    "canNotStartAfterEnd": "Can not start after end",
    "insertNumber": "Insert number",
    "days": "Day(s)",
    "weeks": "Week(s)",
    "months": "Month(s)",
    "years": "Year(s)"
  },
  "menu": {
    "home": "Home",
    "departments": "Departments",
    "institutions": "Institutions",
    "users": "Users",
    "scheduling": "Scheduling",
    "procedures": "Procedures",
    "study": "Study",
    "survey": "Survey",
    "procedure": "Procedure",
    "reinviteusers": "Re-Invite Users",
    "userGuide": "User Guide",
    "devices": "Devices",
    "groups": "Groups",
    "learningobject": "Learning Objects",
    "manageStudies": "Manage Studies",
    "statistics": "Statistics",
    "reports": "Reports",
    "deviceGroups": "Device Groups",
    "patients": "Patients",
    "nurseLocation": "Nurse location",
    "usersList": "Users list",
    "visitForms": "Visit forms",
    "billing": "Billing Portal"
  },
  "procedures": {
    "procedures": "Procedures",
    "searchProcedures": "Search procedures",
    "addProcedure": "Add procedure",
    "deleteProcedure": "Delete procedure",
    "filter": "Filter",
    "sort": "Sort",
    "public": "Public",
    "private": "Private",
    "department": "Department",
    "category": "Category",
    "publicPrivate": "Public/Private",
    "importProcedures": "Import procedures",
    "addAndSchedule": "Add and schedule procedures for device groups",
    "addAnother": "Add another procedure",
    "selectType": "Select type",
    "saveProcedure": "Save procedure",
    "noFrequency": "No frequency added"
  },
  "procedure": {
    "name": "Name",
    "disableProcedure": "Disable procedure",
    "type": "Type",
    "revisionHistory": "Revision history",
    "editProceduresInformation": "Edit procedure information",
    "procedureNotFound": "Procedure not found",
    "category": "Category",
    "authors": "Author",
    "owner": "Owner",
    "languagesAvailable": "Languages available",
    "publicPrivate": "Public/Private",
    "defineFeedback": "Define feedback",
    "seeFeedback": "See feedback",
    "statistics": "Statistics",
    "description": "Description",
    "information": "Information",
    "step": "Step",
    "media": "Media",
    "allSteps": "All steps",
    "createNewStep": "Add step",
    "viewAs": "View as",
    "searchSteps": "Search steps...",
    "procedureName": "Procedure name",
    "procedureCategory": "Procedure category",
    "language": "Language",
    "procedureLanguage": "Procedure language",
    "public": "Public",
    "unableToLoad": "Unable to load procedure",
    "department": "Department",
    "addNewCategory": "ADD NEW CATEGORY",
    "institution": "Institution",
    "import": "Import",
    "stepNr": "Nr",
    "deleteStep": "Confirm to delete step ",
    "lastUpdated": "Last updated",
    "startTime": "Procedure start time",
    "endTime": "Procedure end time"
  },
  "reports": {
    "reports": "Reports",
    "chooseADate": "Choose a date",
    "userID": "User ID",
    "deviceGroup": "Device Group",
    "allReports": "All reports",
    "failedAudits": "Failed audits",
    "reportDate": "Report date",
    "all": "All",
    "successfull": "Successful",
    "failed": "Failed",
    "finished": "Finished",
    "stopped": "Stopped",
    "started": "Started",
    "deviceStatistics": "Device statistics",
    "devicesInUse": "Devices in use",
    "deviceAudits": "Device audits",
    "auditComingSoon": "Audit coming soon",
    "auditNotDone": "Audit not done",
    "auditDone": "Audit done",
    "averageTimeSpentOnProcedure": "Average time spent on procedure",
    "selectProcedure": "Select procedure",
    "noGroupSelected": "No group selected",
    "rateFailedAudits": "Rate of devices failed the audits",
    "proceduresHistory": "Procedures history",
    "procedureStatus": "Procedure status",
    "noProcedureHistory": "No procedure history"
  },
  "devices": {
    "group": "Group",
    "devices": "Devices",
    "searchDevices": "Search devices",
    "addDevice": "Add device",
    "addDevices": "Add devices",
    "addAnotherDevice": "Add another device",
    "deleteDevice": "Delete device",
    "filter": "Filter",
    "sort": "Sort",
    "public": "Public",
    "private": "Private",
    "department": "Department",
    "category": "Category",
    "publicPrivate": "Public/Private",
    "importDevices": "Import devices",
    "allDevices": "All devices"
  },
  "device": {
    "device": "Device",
    "name": "Name",
    "disableDevice": "Disable device",
    "revisionHistory": "Revision history",
    "editDevicesInformation": "Edit device information",
    "deviceNotFound": "Device not found",
    "category": "Category",
    "authors": "Author",
    "owner": "Owner",
    "languagesAvailable": "Languages available",
    "publicPrivate": "Public/Private",
    "defineFeedback": "Define feedback",
    "seeFeedback": "See feedback",
    "statistics": "Statistics",
    "description": "Description",
    "information": "Information",
    "media": "Media",
    "viewAs": "View as",
    "deviceName": "Device name",
    "deviceCategory": "Device category",
    "language": "Language",
    "deviceLanguage": "Device language",
    "public": "Public",
    "unableToLoad": "Unable to load device",
    "department": "Department",
    "group": "Group",
    "addNewCategory": "ADD NEW CATEGORY",
    "institution": "Institution",
    "import": "Import",
    "model": "Device Model",
    "lifeCycleNum": "Life Cycle Number",
    "lifeCycleTime": "Life Cycle Time",
    "lifeCycle": "Life Cycle",
    "udiQrCodef": "UDI for QR code",
    "uuid": "UUID",
    "orUploadPicture": "or upload picture of QR code",
    "dropFile": "Drag and drop a file here, or:",
    "lastUpdated": "Last updated",
    "viewStatistics": "View statistics",
    "auditFrequency": "Audit frequency",
    "auditProcedure": "Audit procedure",
    "lifeCycleStart": "Life cycle start",
    "lifeCycleEnd": "Life cycle end",
    "deviceProcedureHistory": "Device Procedure History",
    "comments": "Comments",
    "commented": "commented",
    "groupName": "Group name",
    "audit": "Audit",
    "other": "Other",
    "udiAlreadyExists": "this UDI already exists",
    "status": "Status"
  },
  "step": {
    "transitionToNextStep": "Transition to next step",
    "transitionType": "Transition type",
    "parentStep": "Parent step",
    "previousStep": "Previous step",
    "option": "Option",
    "editStep": "Edit Step",
    "description": "Description",
    "addNewStep": "Add new step",
    "owner": "Owner",
    "viewInProcedure": "View in procedure",
    "stepMedia": "Step media",
    "saveMedia": "Save",
    "dropFilesOrClickToUpload": "Drop files here or click to upload",
    "addDescription": "Add description",
    "chooseType": "Choose type",
    "insertOption": "Insert option",
    "insertMinValue": "Insert MIN value",
    "insertMaxValue": "Insert MAX value",
    "chooseTransitionType": "Choose transition type",
    "chooseParentSep": "Choose parent step",
    "chooseStepOption": "Choose step option",
    "addParentStep": "Add parent step",
    "type": "Type",
    "value": "Value",
    "error": {
      "WONT_REACH_END": "No path to END",
      "EXIT_NOT_IN_USE": "Unused exit",
      "NO_PARENT_SET": "Has no previous step",
      "PARENT_NOT_EXITS": "Defined parent does not exit"
    }
  },
  "department": {
    "institution": "Institution name",
    "createNewDepartment": "Add department",
    "searchDepartments": "Search department(s)",
    "departmentName": "Department name",
    "institutionName": "Institution name",
    "departmentAdmin": "Department admin",
    "thisFieldIsRequired": "This field is required",
    "addDepartment": "Add department",
    "edit": "Edit",
    "updatedDepartment": "Updated department",
    "createdNewDepartment": "Created new department"
  },
  "user": {
    //new translations
    "deleted": "User/s deleted",
    "totalUsers": "Total users",
    "seatCap": "Seat cap",
    "users": "users",
    "seatsUsed": "Seats used",
    "seatsRemaining": "seats remaining",
    "confirms": {
      "deleteTitle": "Delete {count} user(s)",
      "deleteText": "Deleting user(s) is irreversible. Are you sure you wish to delete the user(s)?",

      "disableTitle": "Disable subscription for {count} user(s)",
      "disableText": "Are you sure you want to disable the subscription for the selected user(s)? This will revoke access to both the CoNurse app and the CMS.",

      "activateTitle": "Activate subscription for {count} user(s)",
      "activateText": "Are you sure you want to activate the subscription for the selected user(s)? This will grant access to the app and the CMS.",

      "notAbleActivateTitle": "Not able to activate subscription for {count} user(s)",
      "notAbleActivateText": "You can only activate subscription for users who are currently disabled. Please adjust your selection to include only disabled users.",

      "notAbleActivateLimitTitle": "Not able to activate subscription for {count} user(s)",
      "notAbleActivateLimitText": "Cannot activate subscription for {count} user(s), this exceeds your seat limit by {seats} seats.",

      "notAbleDisableTitle": "Not able to disable subscription for {count} user(s)",
      "notAbleDisableText": "You can only disable subscription for users who currently have an active subscription. Please adjust your selection to include only active users.",

      "seatLimitReachedTitle": "Seat limit reached",
      "seatLimitReachedText": "Your plan only allows {limit} user(s). Upgrade plan to add more users.",

      "inviteActivateLimitTitle": "Not able to invite {count} user(s)",
      "inviteActivateLimitText": "Cannot invite {count} user(s), this exceeds your seat limit by {seats} seats.",

      "inviteSeatLimitReachedTitle": "Seat limit reached",
      "inviteSeatLimitReachedText": "Your plan only allows {limit} user(s). Upgrade plan to invite more users."
    },

    "lastActive": "Last active",
    "selected": "users selected",
    "chooseAction": "Choose action",
    "deleteSelected": "Delete selected",
    "disableSelected": "Disable selected",
    "enableSelected": "Enable selected",
    //new translations end
    "inviteUsers": "Invite users",
    "reInviteUsers": "Re-invite users",
    "searchUsers": "Search user(s)",
    "user": "User",
    "institutionAndDepartment": "Institution and department",
    "subscription": "Subscription",
    "chooseUserRole": "Choose user role",
    "userRole": "User role",
    //new
    "selectRole": "Select role",
    "selectDepartment": "Select department",
    //end new
    "emails": "User email(s)",
    "department": "Department",
    "departmentAdmin": "Department admin",
    "emailsDescription": "Insert 1 or more e-mails, separated by semicolon. Invitations to register as the chosen user role will be sent to the users via email.",
    "thisFieldIsRequired": "This field is required",
    "nurse": "Nurse",
    "patient": "Patient",
    "contentEditor": "Content Editor",
    "projectAdmin": "Project Admin",
    "familyMember": "Family Member",
    "institutionalAdmin": "Institutional admin",
    "institution": "Institution",
    "filter": "Filter",
    "sort": "Sort",
    "accountSettings": "Account settings",
    "logOut": "Log Out",
    "contactInformation": "Contact information",
    "dateOfBirth": "Date of birth",
    "gender": "Gender",
    "contact": "Contact",
    "password": "Password",
    "userInformation": "User information",
    "resetPassword": "Reset password",
    "sendResetPasswordEmailTo": "Send reset password email to",
    "resetRequestSentTo": "Password rest email sent to",
    "userDetailsUpdated": "User details updated",
    "noUsersSelected": "No users selected",
    "invite": "INVITE",
    "homeNurse": "Home nurse"
  },
  "institution": {
    "name": "Name",
    "region": "Region",
    "contact": "Contact",
    "searchInstitutions": "Search institution(s)",
    "createNewInstitution": "Add institution",
    "switch": "Switch",
    "unableToSwitch": "Unable to switch",
    "switchedTo": "Institutions switched to",
    "street": "Street",
    "institutionStreet": "Street",
    "institutionHouse": "House",
    "institutionCity": "City",
    "institutionCounty": "County",
    "institutionCountry": "Country",
    "institutionTimezone": "Timezone",
    "institutionLanguage": "Language",
    "createdNewInstitution": "Created new institution",
    "updatedInstitution": "Updated institution",
    "edit": "Edit"

  },
  "datatable": {
    "rowsPerPage": "Rows per page"
  },
  "study": {
    "name": "Name",
    "studyName": "Study name",
    "status": "Status",
    "department": "Department",
    "author": "Author",
    "owner": "Owner",
    "duration": "Duration",
    "startDate": "Start date",
    "endDate": "End Date",
    "searchStudy": "Search studies",
    "addStudy": "Add study",
    "description": "Description",
    "visibility": "Visibility",
    "permission": {
      "department": "Department",
      "institution": "Institution",
      "public": "Public"
    },
    "createdNewStudy": "Created new study",
    "updatedStudy": "Updated study",
    "deleteStudy": "Delete study",
    "editStudy": "Edit study",
    "deletedStudy": "Deleted study"
  },
  "studyResults": {
    "user": "User",
    "department": "Department",
    "study": "Study",
    "date": "Date",
    "survey": "Survey",
    "results": "Results",
    "studyResults": "Study Results",
    "surveyResults": "Survey Results",
    "list": "List",
    "graph": "Graph",
    "surveyStartDate": "Survey Start",
    "surveyEndDate": "Survey End",
    "userResults": "User Results",
    "question": "Question",
    "questionType": "Question Type",
    "answer": "Answer",
    "position": "Position"
  },
  "survey": {
    "key": "Key",
    "name": "Name",
    "allAssessmentPeriods": "All assessment periods",
    "createNewPeriod": "Create new period",
    "createNewSurvey": "Create new survey",
    "addAssessmentPeriod": "Create new sub-period",
    "addSurveyPeriod": "Create new survey period",
    "periodName": "Name",
    "completePreviousPeriods": "Does the study participant have to complete a previous period(s) to enable this period?",
    "startDate": "Start date",
    "endDate": "End date",
    "author": "Author",
    "duration": "Duration",
    "type": "Type",
    "SURVEY_PERIOD": "SURVEY PERIOD",
    "NONE": "NONE",
    "ASSESSMENT_PERIOD": "ASSESSMENT PERIOD",
    "addPeriod": "Add new period",
    "questionList": "Questions",
    "added": "Created new survey",
    "createNewQuestion": "Add question",
    "addNew": "Add new",
    "period": "Period",
    "question": "Question",
    "position": "Position",
    "surveyHasOverallScore": "Does the survey have an overall score?",
    "howScoreCalculated": "How is the overall score calculated?",
    "surveyHasCategoryScore": "Does the survey have a category specific score?",
    "sumAnswers": "Sum of all answers",
    "avgAnswers": "Average of all answers",
    "basicInformation": "Basic Information",
    "surveyScore": "Survey Score",
    "addAnotherCategory": "Add another category",
    "selectOption": "Select option",
    "selectSurvey": "Select survey",
    "jobEngagement": "Job-engagement",
    "burnoutScores": "Burnout scores",
    "viewScores": "VIEW SCORES",
    "hasOverallScore": "Survey has overall score",
    "hasNoOverallScore": "Survey has no overall score",
    "noChartData": "No chart data",
    "selectChartType": "Select chart type",
    "surveyCategoryInfo": "The survey has categories to organize questions. You have the ability to modify and oversee them in this section."
  },
  "question": {
    "name": "Name",
    "type": "Type",
    "questionType": "Question type",
    "position": "Position",
    "details": "Details",
    "question": "Question",
    "answers": "Answers",
    "set": "Set",
    "text": "Text",
    "options": "Options",
    "value": "Value",
    "meaning": "Meaning",
    "category": "Category",
    "types": {
      "CHOICE": "Choice",
      "SCALE": "Scale",
      "COGNITION": "Cognition",
      "FREE_TEXT": "Free Text",
      "MULTI_CHOICE": "Checkbox",
      "MEDIA": "Media"
    },
    "added": "Created new question",
    "updated": "Question updated",
    "cognitionName": "Cognition name",
    "cognitionType": "Cognition type",
    "editQuestion": "Edit question"
  },
  "category": {
    "category": "Category",
    "name": "Name",
    "description": "Description",
    "shortDescription": "Short description",
    "createdNewCategory": "Created new category",
    "manageCategories": "Manage categories",
    "deleteCategory": "Delete category",
    "createAnother": "Create another category",
    "deleteAlert": "Deleting this category is irreversible. Move its questions to an existing category or leave them unsorted.",
    "deleteMoveTarget": "Where should the questions from this category go?",
    "noCategory": "No category"
  },
  "groups": {
    "createNewGroup": "Add group",
    "searchGroups": "Search group(s)",
    "addGroup": "Add group",
    "newGroup": "New group",
    "groupName": "Group name",
    "lifeCycleEndingSoon": "Life cycle ending soon",
    "lifeCycleEnded": "Life cycle ended",
    "happyDevices": "Happy devices",
    "searchDeviceGroups": "Search device groups",
    "backToGroups": "Back to device groups",
    "saveGroup": "Save group"
  },
  "group": {
    "name": "Name",
    "description": "Description",
    "createdNewGroup": "Created new group",
    "updatedGroup": "Updated group",
    "groupCategory": "Group category",
    "category": "Category",
    "addNewCategory": "ADD NEW CATEGORY",
    "language": "Language",
    "groupLanguage": "Group language",
    "public": "Public",
    "private": "Private",
    "groupName": "Group name",
    "departmentName": "Department name",
    "created_at": "Created at",
    "notFound": "Group not found",
    "notCreated": "Not created",
    "noImage": "No image added"
  },
  "learningObject": {
    "addLearningObject": "Add learning object",
    "searchLearningObject": "Search learning objects",
    "name": "Name",
    "department": "Department",
    "content": "Content",
    "isEnabled": "Enabled",
    "updatedLearningObject": "Updated learning object",
    "createdNewLearningObject": "Created new learning object",
    "author": "Author",
    "owner": "Owner",
    "editLearningObject": "Edit learning object",
    "deleteLearningObject": "Delete learning object",
    "learningObjectDeleted": "Deleted learning object"
  },
  "manual": {
    "userManuals": "User manuals",
    "userManual": "User Manual",
    "chooseOrWrite": "Choose an existing user manual or write a new one.",
    "userManualName": "User Manual name",
    "writeText": "Write user manual text",
    "input": "Input",
    "saveUserManual": "Save user manual",
    "addUserManual": "Add another user manual",
    "writeNew": "or use write a new user manual",
    "searchExisting": "Search existing user manual..."
  },
  "patients": {
    "patientName": "Patient name",
    "patientAssignedTo": "Patient assigned to",
    "datePatientAdded": "Date patient added",
    "status": "Status",
    "nextVisit": "Next visit",
    "addPatient": "Add patient",
    "editPatient": "Edit patient",
    "importPatients": "import patients",
    "patientSearch": "Patient search",
    "scheduleVisit": "Schedule a visit",
    "primaryDiagnosis": "Primary diagnosis",
    "secondaryDiagnosis": "Secondary diagnosis",
    "patientHistory": "Patient history",
    "enterName": "Enter name",
    "birthDate": "Birth date",
    "visitAddress": "Visit address",
    "enterAddress": "Enter address",
    "email": "Email",
    "enterPatientEmail": "Enter patient's email",
    "phoneNumber": "Phone number",
    "enterPatientNumber": "Enter patient's phone number",
    "enterPrimaryDiagnosis": "Enter primary diagnosis",
    "enterSecondaryDiagnosis": "Enter secondary diagnosis",
    "note": "Note (optional)",
    "enterShortNote": "Enter short note",
    "assignedNurse": "Assigned nurse",
    "fileRequirements": "File requirements",
    "firstRequirement": "Please upload XLS or csv file",
    "secondRequirement": "Less than 500 KB",
    "allergy": "Allergy",
    "allergies": "Allergies",
    "allergyType": "Allery type (optional)",
    "medications": "Medications",
    "procedures": "Procedures",
    "reaction": "Reaction (optional)",
    "severity": "Severity (optional)",
    "addAnotherAllergy": "Add another allergy",
    "medication": "Medication",
    "medicationType": "Medication type",
    "dosage": "Dosage",
    "frequency": "Frequency",
    "startDateOptional": "Start date (optional)",
    "durationOptional": "Duration (optional)",
    "addAnotherMedication": "Add another medication",
    "addAnotherProcedure": "Add another procedure",
    "visit": "Visit",
    "visitStartTime": "Visit start time",
    "visitEndTime": "Visit end time",
    "selectNurse": "Select nurse",
    "addAnotherVisit": "Add another visit",
    "sex": "Sex",
    "addNewAllergy": "Add new allergy",
    "addNewMedication": "Add new medication",
    "addNewProcedure": "Add new procedure",
    "assignedProcedures": "Assigned procedures",
    "scheduledProcedures": "Scheduled procedures",
    "upcomingVisits": "Upcoming visits",
    "canceledVisits": "Cancelled visits",
    "pastVisits": "Past visits",
    "department": "Department",
    "scheduledVisits": "Scheduled visits",
    "visitAssignedTo": "Visit assigned to",
    "stable": "Stable",
    "improving": "Improving",
    "deteriorating": "Deteriorating",
    "notAssigned": "Not assigned",
    "ongoing": "Ongoing",
    "pending": "Pending",
    "finished": "Finished"

  },
  "visitReport": {
    "consent": "Consent",
    "viewConsent": "View consent",
    "homeVisit": "Home visit",
    "recomendationForTreatment": "Recomendations for treatment, care, work, and outpatient supervision",
    "anamnesis": "Anamnesis",
    "answerType": "Answer type",
    "contactPhone": "Contact phone",
    "contactEmail": "Contact email",
    "visitMadeBy": "Visit made by",
    "homeVisitTime": "Home visit time",
    "visitForm": "Visit form",
    "viewHistory": "View history",
    "patientsPrimaryHealthConcern": "Patients primary health concern",
    "conditionAssesmentInformation": "Condition assesment information",
    "bloodPressure": "Blood pressure",
    "measurement": "Measurement",
    "BMI": "BMI",
    "diagnosis": "Diagnosis",
    "appliedMedicalTreatments": "Applied medicinal treatment",
    "appliedTreatment": "Applied treatment",
    "descriptionOfTestsConsultationPlans": "Description of tests/consultation plans",
    "instrumentalTests": "Instrumental tests",
    "laboratoryTests": "Laboratory tests",
    "appliedMedicalTreatment": "Applied medical treatment",
    "specialist": "Specialist",
    "status": "Status",
    "complaintData": "Complaint data",
    "pulse": "Pulse",
    "viewFullVisitForm": "View full visit form",
    "height": "Height",
    "weight": "Weight"

  },
  "titles": {
    //new
    "billingplans": "Billing Plans",
    "reinviteusers": "Re-Invite Users",
    //end new
    "home": "Home",
    "institutions": "Institutions",
    "departments": "Departments",
    "users": "Users",
    "nurselocation": "Nurse Location",
    "procedures": "Procedures",
    "study": "Study",
    "learningobjects": "Learning Objects",
    "patients": "Patients",
    "patient": "Patient",
    "visit forms": "Visit Forms",
    "backToUsers": "Back to users",
    "backToVisits": "Back to visits",
    "backToPatientsList": "Back to patients list",
    "backToPatient": "Back to patient",
    "backToProcedures": "Back to procedures",
    "backToProcedure": "Back to procedure",
    "backToStudyList": "Back to study list",
    "backToStatistics": "Back to statistics",
    "backToStudy": "Back to study",
    "backToLearningObjects": "Back to learning objects",
    "studyresults": "Study results",
    "studyview": "Study view",
    "learningobjectdetail": "Learning object details",
    "subscription": "Subscription",
    "scheduling": "Scheduling",
    "signup": "Signup",
    "userresults": "User results",
    "devices": "Devices",
    "device": "Device",
    "groups": "Groups",
    "group": "Group",
    "groupadd": "Add Group",
    "devicereports": "Device reports",
    "devicecharts": "Device charts",
    "visitforms": "Visit forms",
    "procedure": "Procedure",
    "step": "Step",
    "addpatient": "Add patient",
    "editpatient": "Edit patient",
    "survey": "Survey",
    "surveyresults": "Survey results",
  }
}
